// extracted by mini-css-extract-plugin
export default {"desktop":"ui_desktop__7OWSV","service":"ui_service__2LQ12","notice":"ui_notice__qtkxS","notice_icon":"ui_notice_icon__pZdkO","restored":"ui_restored__a+huz"};